import Link from "next/link";
import { ToyotaLogo } from "@/components/Logos/ToyotaLogo";
import { cn } from "@/lib/utils";
import pages from "../../../public/content/home-nav-data.json";

type Page = {
  name: string;
  href?: string;
  modalId?: string;
};

type HeaderBarProps = {
  className?: string;
  children?: React.ReactNode;
  openModal?: (modalId: string) => void;
};

const Navigation: React.FC<HeaderBarProps> = ({ className, openModal }) => (
  <nav className={cn("flex select-none justify-center space-x-10", className)}>
    {pages.map((page: Page) => (
      <div key={page.name}>
        {page.modalId ? (
          <button onClick={() => page.modalId && openModal?.(page.modalId)}>
            {page.name}
          </button>
        ) : (
          <Link href={page.href ?? "#"}>{page.name}</Link>
        )}
      </div>
    ))}
  </nav>
);

const Logo: React.FC<HeaderBarProps> = ({ className, children }) => (
  <div className={cn("flex justify-start", className)}>{children}</div>
);

export const HomeNav: React.FC<{ openModal: (modalId: string) => void }> = ({
  openModal,
}) => {
  return (
    <div className="flex w-full items-center justify-between">
      <Logo className="w-1/4 pl-12">
        <Link href="/">
          <ToyotaLogo />
        </Link>
      </Logo>
      <Navigation className="w-2/4" openModal={openModal} />
      <div className="w-1/4"></div> {/* Empty div to balance the layout */}
    </div>
  );
};
